<!-- header -->
<header class="simple-header">
  <a (click)="goToHomePage()" class="clickable-hover wazari-logo"></a>
</header>
<!-- body -->
<div class="simple-body">
  <main class="simple-main">
    <div class="simple-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<!-- footer -->
<wz-footer></wz-footer>
